/* unplugin-vue-components disabled */import { render } from "./MappingLegend.vue?vue&type=template&id=6af3be70&scoped=true"
import script from "./MappingLegend.vue?vue&type=script&lang=js"
export * from "./MappingLegend.vue?vue&type=script&lang=js"

import "./MappingLegend.vue?vue&type=style&index=0&id=6af3be70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af3be70"]])

export default __exports__